<section
	[editableInStoryblok]="_editable()"
	class="section-gap-wide section-spacing px-0"
	data-test-class="feature-split-section"
>
	@for (featureSplit of splits(); track featureSplit._uid; let odd = $odd) {
		<vp-feature-split
			[editableInStoryblok]="featureSplit._editable"
			[images]="featureSplit.photos"
			[inverse]="odd !== startInversed()"
		>
			@for (heading of featureSplit.heading; track heading._uid) {
				<ndc-dynamic
					[ndcDynamicComponent]="components[heading.component]"
					[ndcDynamicInputs]="heading"
					class="hidden"
				/>
			}
			@for (blok of featureSplit.content; track blok['_uid']) {
				<ndc-dynamic
					[ndcDynamicComponent]="components[blok.component]"
					[ndcDynamicInputs]="blok"
					class="hidden"
				/>
			}
			@for (blok of featureSplit.button; track blok['_uid']) {
				<ndc-dynamic
					[ndcDynamicComponent]="components[blok.component]"
					[ndcDynamicInputs]="blok"
					class="hidden"
				/>
			}
		</vp-feature-split>
	}
</section>
